import { render } from "./ListeModeleSignatairePage.vue?vue&type=template&id=2643ba5b&ts=true"
import script from "./ListeModeleSignatairePage.vue?vue&type=script&lang=ts"
export * from "./ListeModeleSignatairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__